export const pickDefaultSchool = (list, user) => {
  if (!list?.length) return "";
  if (user?.school_id && list.some((s) => s.id === user.school_id)) return user.school_id;
  return list[0].id;
};
